var map = {
	"./BASE.svg": 57197,
	"./BF.svg": 31246,
	"./BJ.svg": 92922,
	"./BTC.svg": 30087,
	"./BW.svg": 18063,
	"./CD.svg": 65647,
	"./CELO.svg": 64237,
	"./CG.svg": 86620,
	"./CI.svg": 89418,
	"./CM.svg": 24406,
	"./CUSD.svg": 58351,
	"./ERC20.svg": 47584,
	"./ETH.svg": 33387,
	"./GA.svg": 49366,
	"./KE.svg": 27622,
	"./MATIC.svg": 16344,
	"./ML.svg": 15969,
	"./MW.svg": 21178,
	"./NG.svg": 72179,
	"./POL.svg": 75151,
	"./POLYGON.svg": 77092,
	"./PYUSD.svg": 62749,
	"./RLUSD.svg": 93740,
	"./RW.svg": 88575,
	"./SN.svg": 81445,
	"./SOL.svg": 68184,
	"./Search.svg": 35078,
	"./TG.svg": 99661,
	"./TON.svg": 62297,
	"./TRC20.svg": 41025,
	"./TRON.svg": 80115,
	"./TZ.svg": 15784,
	"./Text.svg": 97443,
	"./UG.svg": 71282,
	"./USDC.svg": 16049,
	"./USDT.svg": 33342,
	"./XAUT.svg": 85636,
	"./XLM.svg": 57675,
	"./XRP.svg": 62604,
	"./ZA.svg": 75241,
	"./ZM.svg": 51277,
	"./angle-down.svg": 63552,
	"./check-circle.svg": 58075,
	"./circleInfo.svg": 70910,
	"./close-alt.svg": 35032,
	"./copy-white.svg": 72737,
	"./copy.svg": 55357,
	"./edit.svg": 92170,
	"./eye-slash.svg": 53213,
	"./eye.svg": 28097,
	"./greenClose.svg": 80705,
	"./trash-black.svg": 57986,
	"./trash.svg": 37480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78002;